import styled from "@emotion/styled";

export const Main = styled.div`
  grid-area: main;
  display: flex;
  flex-direction: column;
  background: var(--bg);
  overflow: hidden;
`;
